/**
 * @flow
 */

const host = 'https://www.universe.com';
const widgets = 'https://widgets.universe.com';

export default {
  api: {
    base: `${host}/api/v2`,
    host,
  },
  basename: '/embed2',
  debug: false,
  environment: 'production',
  explore: `${host}/explore`,
  googleTagManager: {
    gtmId: 'GTM-K4QMLG'
  },
  amplitude: {
    api_key: '8f3073b2e3efb3028708aeca4bff06f5',
  },
  juno: `${host}/embed2`,
  betaCalendar: `${widgets}/calendar`,
  betaCheckout: `${widgets}`,
  calendar: 'https://redirect.universe.com/redirect',
  tickets: 'https://redirect.universe.com/redirect',
  checkout: 'https://redirect.universe.com/redirect',
  listings: 'https://redirect.universe.com/redirect',
  sift: '877eac203a',
  oAuth: {
    url: `${host}/v2/oauth/token`
  },
  turnstile: {
    siteKeyManaged: '0x4AAAAAAB25iGQ-QNQq8L8o',
    siteKeyInvisible: '0x4AAAAAAB25j6vBHLEpI4DD'
  },
  sentryDSN: 'https://a59375f16202433da3b739306c0c43fa@app.getsentry.com/90180',
  visaCheckoutKey: 'E3LCVMPC93648A1AMTMN21hX0x_D3YEYiFLz2qgOM_h7ffXUE',
  visaCheckoutButton: 'https://secure.checkout.visa.com/wallet-services-web/xo/button.png',
  visaCheckout: 'https://assets.secure.checkout.visa.com',
  masterPass: 'https://masterpass.com/switchui/index.html',
  masterPassCheckoutId: 'f47b2c83cd904fbe8eb80eb07c26f06b',
  masterPassJs: 'https://masterpass.com/integration/merchant.js',
  universeLogo: 'https://cdn-assets-cloud.frontify.com/local/frontify/h_lNxVXLqrDqb2kyrixW3lMmUl7n-aBRzJUzyvzD7_9R_ZbVNQokieTtMAAhc7AOjJW2ZVOhdG_ZaFz1P73h5K_PuKvlHeLdvkGc7D-L2VZUndxhrXXrAmgvUSg48t7Z?width=2400',
  googleMapApiKey: 'AIzaSyD3q6LYn2E79CCBR1g_NG3NbdK8IFPN2g8',
  userEmailForMotoParamTest: 'andrew.barkman@universe.com'
};



// WEBPACK FOOTER //
// ./config/production.js